<template>
  <div class="Add_scale">
    <el-form ref="form" label-width="80px" style="padding-top: 20px;margin-left: 20px;">
      
      <el-form-item label="量表归类">
        <el-input placeholder="量表归类" v-model="lbname" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item label="量表代号">
        <el-input :disabled="this.$route.query.paperCode" v-model="paperCode" placeholder="量表代号"></el-input>
      </el-form-item>

      <el-form-item label="量表名称">
        <el-input v-model="paperName" placeholder="量表名称"></el-input>
      </el-form-item>

      <el-form-item label="量表封面">
        <div class="cover" style="margin-left:-70px">
          <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">
              <span style="font-size: 16px;">点击选择封面</span>
            </i>
          </el-upload>
        </div>
      </el-form-item>

      <el-form-item label="内容图片">
        <div class="cover" style="margin-left:-70px">
          <el-upload :on-change="handleChange2" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
            <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">
              <span style="font-size: 16px;">点击选择封面</span>
            </i>
          </el-upload>
        </div>
      </el-form-item>

      <el-form-item label="量表粗分公式">
        <el-input type="textarea" v-model="calFormula"  placeholder="量表粗分公式"></el-input>
      </el-form-item>

      <el-form-item label="量表转换公式">
        <el-select v-model="tranFormula" placeholder="量表转换公式">
          <el-option v-for="item in indexval" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
          </el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="年龄段">
        <el-input placeholder="开始年龄段" style="width: 100px !important;" v-model="startAge"></el-input> - <el-input style="width: 100px !important;" v-model="endAge" placeholder="结束年龄段"></el-input>
      </el-form-item>
      
      <el-form-item label="性别">
        <el-radio-group v-model="sex">
          <el-radio label="-1">不区分</el-radio>
          <el-radio label="1">男</el-radio>
          <el-radio label="0">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标准分">
        <el-input v-model="sd" placeholder="标准分"></el-input>
      </el-form-item>

      <el-form-item label="平均数">
        <el-input v-model="averageNum" placeholder="平均数"></el-input>
      </el-form-item> -->


      <div>
        <el-button type="primary" @click="addd()">添加</el-button>
        <table border="1">
          <tr>
            <th>开始年龄</th>
            <th>结束年龄</th>
            <th>性别</th>
            <th>标准差</th>
            <th>平均数</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item,i) in data" :key="i">
            <td><el-input style="width: 100px;" v-model="item.startAge"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.endAge"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.sex"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.sd"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.averageNum"></el-input></td>
            <td @click="dies(i)">删除</td>
          </tr>
        </table>
      </div>

      <el-form-item label="量表排序">
        <el-input v-model="lineNumber" placeholder="量表排序"></el-input>
      </el-form-item>

      <el-form-item label="量表基准分">
        <el-input v-model="baselineScore" placeholder="量表基准分"></el-input><span style="color: red;">说明:只能输入数字</span> 
      </el-form-item>

      <el-form-item label="量表计时">
        <el-input v-model="timekeeping" placeholder="量表计时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表限时">
        <el-input v-model="timeLimit" placeholder="量表限时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表题目计时">
        <el-input v-model="questionTimekeeping" placeholder="量表题目计时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="量表题目限时">
        <el-input v-model="questionTimeLimit" placeholder="量表题目限时"></el-input> 单位：秒 <span style="color: red;">单位：秒 说明:只能输入数字。</span> 
      </el-form-item>

      <el-form-item label="是否有因子">
        <el-radio-group v-model="hasFactor">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否允许漏题">
        <el-radio-group v-model="IsMissQuestion">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否有均分">
        <el-radio-group v-model="isAverageScore">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="原始分报告展示">
        <el-radio-group v-model="printIniScore">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标准分报告展示">
        <el-radio-group v-model="printStandScore">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="均分报告展示">
        <el-radio-group v-model="printAverageScore">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="常模报告展示">
        <el-radio-group v-model="printAverageNumSD">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="总分报告展示">
        <el-radio-group v-model="printPaperScore">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="参考诊断报告展示">
        <el-radio-group v-model="printDiagnostic">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="量表结果特征">
        <el-radio-group v-model="resultFeature">
          <el-radio label="1">结果等级</el-radio>
          <el-radio label="2">危机预警</el-radio>
          <el-radio label="3">结果等级和危机预警</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="因子分">
        <el-radio-group v-model="factorScore">
          <el-radio label="0">无</el-radio>
          <el-radio label="1">有</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="量表分">
        <el-radio-group v-model="scaleScore">
          <el-radio label="0">无</el-radio>
          <el-radio label="1">有</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="原始分取值方式">
        <el-radio-group v-model="iniCalMethod">
          <el-radio label="1">原始取值</el-radio>
          <el-radio label="2">按模取值</el-radio>
          <el-radio label="3">四舍五入</el-radio>
          <el-radio label="4">四入五入</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标准分取值方式">
        <el-radio-group v-model="ssCalMethod">
          <el-radio label="1">原始取值</el-radio>
          <el-radio label="2">按模取值</el-radio>
          <el-radio label="3">四舍五入</el-radio>
          <el-radio label="4">四入五入</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="平均分取值方式">
        <el-radio-group v-model="aveCalMethod">
          <el-radio label="1">原始取值</el-radio>
          <el-radio label="2">按模取值</el-radio>
          <el-radio label="3">四舍五入</el-radio>
          <el-radio label="4">四入五入</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="平均分公式">
        <el-input type="textarea" v-model="averageFormula" placeholder="平均分公式"></el-input>
      </el-form-item>

      <el-form-item label="功能说明">
        <el-input type="textarea" v-model="introduction" placeholder="功能说明"></el-input>
      </el-form-item>

      <el-form-item label="指 导 语">
        <el-input type="textarea" v-model="guidanceNote" placeholder="指 导 语"></el-input>
      </el-form-item>

      <el-form-item label="推 荐 语">
        <el-input type="textarea" v-model="paperRecommend" placeholder="推 荐 语"></el-input>
      </el-form-item>

      <el-form-item label="计分标准">
        <el-input type="textarea" v-model="scoring" placeholder="计分标准"></el-input>
      </el-form-item>

      <el-form-item label="测评理论">
        <el-input type="textarea" v-model="cpll" placeholder="测评理论"></el-input>
      </el-form-item>

      <el-form-item label="参考文献">
        <el-input type="textarea" v-model="ckwx" placeholder="参考文献"></el-input>
      </el-form-item>

      <el-form-item label="适用范围">
        <el-input type="textarea" v-model="syfw" placeholder="适用范围"></el-input>
      </el-form-item>

      <el-form-item label="测试效果">
        <el-input type="textarea" v-model="csxg" placeholder="测试效果"></el-input>
      </el-form-item>

      <el-form-item label="是否启用">
        <el-radio-group v-model="isactive">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标签">
        <el-input v-model="Tagging" placeholder="标签"></el-input>
      </el-form-item>
    
      <el-form-item>
        <el-button @click="Cancelfun()">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog :visible.sync="dialogVisible" width="600px" style="height: 600px;" :before-close="handleClose">
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>

  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {
      return {
        indexval:[],
        data:[],
        dialogVisible:false,
        lbname:'',//量表名称
        paperCode:'',//量表编号
        paperName:'',//量表名称
        calFormula:'',//粗分公式
        tranFormula:'',//量表转换公式
        startAge:'',//开始年龄
        endAge:'',//截止年龄
        sex:'',//性别
        sd:'',//标准分
        averageNum:'',//平均分
        lineNumber:'',//量表排序
        baselineScore:'',//量表基准分数
        timekeeping:'',//量表计是
        timeLimit:'',//量表现实
        questionTimekeeping:'',//题目即使
        questionTimeLimit:'',//题目现时
        hasFactor:'',//是否有因子
        isAverageScore:'',//是否有平均分值
        printIniScore:'',
        printStandScore:'',
        printAverageScore:'',
        printAverageNumSD:'',
        printPaperScore:'',
        printDiagnostic:'',
        resultFeature:'',
        factorScore:'',
        IsMissQuestion:'',
        scaleScore:'',
        iniCalMethod:'',
        ssCalMethod:'',
        aveCalMethod:'',
        averageFormula:'',
        guidanceNote:'',
        introduction:'',
        paperRecommend:'',
        scoring:'',
        cpll:'',
        ckwx:'',
        syfw:'',
        csxg:'',
        isactive:'',
        Tagging:'',
        imageUrl:'',
        imageUrl2:'',
        fbCover:'',
        fbContent:'',
        ppaperCode:'',
        test:'立即创建',
      };
    },
    components:{
      scales_Pop
    },
    methods: {
      dies(i){
        this.data.splice(i, 1)
      },
      addd(){
        var ss = {
          startAge:'0',
          endAge:'0',
          sex:'0',
          sd:'0',
          averageNum:'0',
        }
        this.data.push(ss);
      },
      getmsg(val){//量表点击时子组件传过来值
        this.lbname = val.label;
        this.ppaperCode = val.val;
      },
      cel(){
        this.dialogVisible = true;
      },
      Cancelfun(){
        this.$router.push({
          path: '/Scale/Scale_classification',
        })
      },
      onSubmit() {
        if(!this.$route.query.paperCode){
          var from = new FormData();
          from.append('fbCover',             this.fbCover.raw);
          from.append('fbContent',           this.fbContent.raw);
          from.append('comTypes',            JSON.stringify(this.data));
          from.append('paperCode',           this.paperCode);
          from.append('paperName',           this.paperName);
          from.append('calFormula',          this.calFormula);
          from.append('tranFormula',         this.tranFormula);
          from.append('startAge',            this.startAge);
          from.append('endAge',              this.endAge);
          from.append('sex',                 this.sex);
          from.append('ppaperCode',          this.ppaperCode);
          from.append('sd',                  this.sd);
          from.append('averageNum',          this.averageNum);
          from.append('lineNumber',          this.lineNumber);
          from.append('baselineScore',       this.baselineScore);
          from.append('timekeeping',         this.timekeeping);
          from.append('timeLimit',           this.timeLimit);
          from.append('questionTimekeeping', this.questionTimekeeping);
          from.append('questionTimeLimit',   this.questionTimeLimit);
          from.append('hasFactor',           this.hasFactor);
          from.append('isAverageScore',      this.isAverageScore);
          from.append('printIniScore',       this.printIniScore);
          from.append('printStandScore',     this.printStandScore);
          from.append('printAverageScore',   this.printAverageScore);
          from.append('printAverageNumSD',   this.printAverageNumSD);
          from.append('printPaperScore',     this.printPaperScore);
          from.append('printDiagnostic',     this.printDiagnostic);
          from.append('resultFeature',       this.resultFeature);
          from.append('factorScore',         this.factorScore);
          from.append('IsMissQuestion',      this.IsMissQuestion);
          from.append('scaleScore',          this.scaleScore);
          from.append('iniCalMethod',        this.iniCalMethod);
          from.append('ssCalMethod',         this.ssCalMethod);
          from.append('aveCalMethod',        this.aveCalMethod);
          from.append('averageFormula',      this.averageFormula);
          from.append('guidanceNote',        this.guidanceNote);
          from.append('introduction',        this.introduction);
          from.append('paperRecommend',      this.paperRecommend);
          from.append('scoring',             this.scoring);
          from.append('cpll',                this.cpll);
          from.append('ckwx',                this.ckwx);
          from.append('syfw',                this.syfw);
          from.append('csxg',                this.csxg);
          from.append('isactive',            this.isactive);
          from.append('Tagging',             this.Tagging);
          this.$Http_Post('/paperconfig/papercfg/add', from, {'Content-Type':'multipart/form-data',}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }else{
          var from = new FormData();
          from.append('fbCover',              this.fbCover.raw);
          from.append('fbContent',            this.fbContent.raw);
          from.append('comTypes',             JSON.stringify(this.data));
          from.append('paperCode',            this.paperCode);
          from.append('paperName',            this.paperName);
          from.append('calFormula',           this.calFormula);
          from.append('tranFormula',          this.tranFormula);
          from.append('startAge',             this.startAge);
          from.append('endAge',               this.endAge);
          from.append('sex',                  this.sex);
          from.append('ppaperCode',           this.ppaperCode);
          from.append('sd',                   this.sd);
          from.append('averageNum',           this.averageNum);
          from.append('lineNumber',           this.lineNumber);
          from.append('baselineScore',        this.baselineScore);
          from.append('timekeeping',          this.timekeeping);
          from.append('timeLimit',            this.timeLimit);
          from.append('questionTimekeeping',  this.questionTimekeeping);
          from.append('questionTimeLimit',    this.questionTimeLimit);
          from.append('hasFactor',            this.hasFactor);
          from.append('isAverageScore',       this.isAverageScore);
          from.append('printIniScore',        this.printIniScore);
          from.append('printStandScore',      this.printStandScore);
          from.append('printAverageScore',    this.printAverageScore);
          from.append('printAverageNumSD',    this.printAverageNumSD);
          from.append('printPaperScore',      this.printPaperScore);
          from.append('printDiagnostic',      this.printDiagnostic);
          from.append('resultFeature',        this.resultFeature);
          from.append('factorScore',          this.factorScore);
          from.append('IsMissQuestion',       this.IsMissQuestion);
          from.append('scaleScore',           this.scaleScore);
          from.append('iniCalMethod',         this.iniCalMethod);
          from.append('ssCalMethod',          this.ssCalMethod);
          from.append('aveCalMethod',         this.aveCalMethod);
          from.append('averageFormula',       this.averageFormula);
          from.append('guidanceNote',         this.guidanceNote);
          from.append('introduction',         this.introduction);
          from.append('paperRecommend',       this.paperRecommend);
          from.append('scoring',              this.scoring);
          from.append('cpll',                 this.cpll);
          from.append('ckwx',                 this.ckwx);
          from.append('syfw',                 this.syfw);
          from.append('csxg',                 this.csxg);
          from.append('isactive',             this.isactive);
          from.append('Tagging',              this.Tagging);
          this.$Http_Post('/paperconfig/papercfg/edit', from, {'Content-Type':'multipart/form-data',}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }
      },
      handleChange(file, fileList) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.fbCover = file;
      },
      handleChange2(file, fileList) {
        this.imageUrl2 = URL.createObjectURL(file.raw);
        this.fbContent = file;
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
      }
    },
    mounted(){
      if(!this.$route.query.paperCode){
  
      }else {
        this.$Http_Post('paperconfig/papercfg/getinfo', { paperCode: this.$route.query.paperCode }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.lbname = res.Data.lbname;
            this.paperCode = res.Data.paperCode;
            this.paperName = res.Data.paperName;
            this.calFormula = res.Data.calFormula;
            this.tranFormula = res.Data.tranFormula;
            this.startAge = res.Data.startAge;
            this.endAge = res.Data.endAge;
            this.sex = res.Data.sex.toString();
            this.sd = res.Data.sd
            this.averageNum = res.Data.averageNum
            this.lineNumber = res.Data.lineNumber
            this.baselineScore = res.Data.baselineScore
            this.timekeeping = res.Data.timekeeping
            this.timeLimit = res.Data.timeLimit
            this.questionTimekeeping = res.Data.questionTimekeeping
            this.questionTimeLimit = res.Data.questionTimeLimit
            this.hasFactor = res.Data.hasFactor.toString()
            this.isAverageScore = res.Data.isAverageScore.toString()
            this.printIniScore = res.Data.printIniScore.toString()
            this.printStandScore = res.Data.printStandScore.toString()
            this.printAverageScore = res.Data.printAverageScore.toString()
            this.printAverageNumSD = res.Data.printAverageNumSD.toString()
            this.printPaperScore = res.Data.printPaperScore.toString()
            this.printDiagnostic = res.Data.printDiagnostic.toString()
            this.resultFeature = res.Data.resultFeature.toString()
            this.factorScore = res.Data.factorScore.toString()
            this.IsMissQuestion = res.Data.isMissQuestion.toString()
            this.scaleScore = res.Data.scaleScore.toString()
            this.iniCalMethod = res.Data.iniCalMethod.toString()
            this.ssCalMethod = res.Data.ssCalMethod.toString()
            this.aveCalMethod = res.Data.aveCalMethod.toString()
            this.averageFormula = res.Data.averageFormula
            this.guidanceNote = res.Data.guidanceNote
            this.introduction = res.Data.introduction
            this.paperRecommend = res.Data.paperRecommend
            this.scoring = res.Data.scoring
            this.cpll = res.Data.cpll
            this.ckwx = res.Data.ckwx
            this.syfw = res.Data.syfw
            this.csxg = res.Data.csxg
            this.isactive = res.Data.isactive
            this.Tagging = res.Data.tagging
            this.imageUrl = res.Data.paperCoverURL
            this.imageUrl2 = res.Data.paperContentURL
            this.ppaperCode = res.Data.ppaperCode
            this.data = res.Data.comTypeList
            this.lbname = res.Data.ppaperName
            this.ppaperCode = res.Data.ppaperCode
            
          }
        })
      }

      this.$Http_Post('User/GetDictionaryList', { DicTypCode: "51" }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.indexval = res.Data;
        }
      })

    }
  };
</script>
<style>
.Add_scale{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Add_scale .el-input{width: 300px;}
.Add_scale .el-textarea{width: 500px;}
.Add_scale .el-form-item__label{width: 120px !important;text-align: right;}
.Add_scale .el-form-item__content{margin-left: 100px !important;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 150px;}
.avatar-uploader {position: absolute;top: 0px;left: 90px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.scale {margin-top: 30px;}
</style>